import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

interface Props {
  searchText: string;
}

// Define the initial state using that type
const initialState: Props = {
  searchText: ''
};

export const fileContentsSlice = createSlice({
  name: 'fileContents',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    }
  },
});

export const {
  setSearchText,
} = fileContentsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectSearchTextFileContents = (state: RootState) => state.fileContents.searchText;

export default fileContentsSlice.reducer;
